import { render, staticRenderFns } from "./xlsx.vue?vue&type=template&id=db42d32c&scoped=true&"
import script from "./xlsx.vue?vue&type=script&lang=js&"
export * from "./xlsx.vue?vue&type=script&lang=js&"
import style0 from "./xlsx.vue?vue&type=style&index=0&id=db42d32c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db42d32c",
  null
  
)

export default component.exports